import { TextDecorator } from "@faire/web-api/indigofair/data/TextDecorator";

export const getDecoratorValuesCSS = (
  decorators?: Array<keyof typeof TextDecorator>
) => {
  const css: React.CSSProperties = {};
  if (!decorators) {
    return css;
  }
  decorators.forEach((decorator) => {
    switch (decorator) {
      case TextDecorator.STRIKE_THROUGH:
        css["textDecoration"] = "line-through";
        break;
      case TextDecorator.UNDERLINE:
        css["textDecoration"] = "underline";
        break;
      default:
        break;
    }
  });
  return css;
};
